export const siteInfo = {
  name: "蘑菇tv成品人",
  tagline: "精选资源汇聚平台",
  description: "蘑菇tv成品人专属频道，汇聚海量精选成品内容资源，为蘑菇tv成品人用户提供一站式内容发现、资源获取与创作灵感平台，助力每一位蘑菇tv成品人快速找到所需优质内容。",
  keywords: "蘑菇tv成品人,蘑菇tv成品人资源,蘑菇tv成品人频道,蘑菇tv成品人合集,蘑菇tv成品人推荐,蘑菇tv内容创作,蘑菇tv资源平台",
  url: "https://mogutv.com",
  logo: "蘑菇tv成品人",
  foundingYear: 2020,
  email: "contact@mogutv.com",
  phone: "400-888-9999",
  address: "北京市朝阳区望京科技园A座1208室",
  wechat: "mogutv_official",
  qq: "88888888",
};

export const categories = [
  {
    slug: "latest-recommend",
    name: "最新推荐",
    description: "编辑精选的优质成品内容，每日更新推荐",
    icon: "ri-star-line",
    color: "accent",
  },
  {
    slug: "creation-tutorial",
    name: "创作教程",
    description: "从入门到精通的创作教学资源合集",
    icon: "ri-book-open-line",
    color: "primary",
  },
  {
    slug: "resource-collection",
    name: "资源合集",
    description: "海量素材模板与成品资源一键下载",
    icon: "ri-folder-zip-line",
    color: "secondary",
  },
  {
    slug: "inspiration-material",
    name: "灵感素材",
    description: "激发创作灵感的视觉素材与案例库",
    icon: "ri-lightbulb-line",
    color: "accent",
  },
  {
    slug: "tools-software",
    name: "工具软件",
    description: "提升创作效率的实用工具与软件推荐",
    icon: "ri-tools-line",
    color: "primary",
  },
  {
    slug: "industry-news",
    name: "行业资讯",
    description: "蘑菇tv平台动态与内容创作行业前沿",
    icon: "ri-newspaper-line",
    color: "secondary",
  },
];

export const stats = [
  { value: "128,000+", label: "注册创作者" },
  { value: "56,000+", label: "成品资源" },
  { value: "380+", label: "创作教程" },
  { value: "99.7%", label: "用户好评率" },
];

export const faqs = [
  {
    question: "蘑菇tv成品人平台是什么？",
    answer: "蘑菇tv成品人是一个专为蘑菇tv内容创作者打造的一站式资源汇聚平台。我们精选海量优质成品内容资源，覆盖创作教程、素材模板、灵感案例、工具软件等多个品类，帮助创作者快速找到所需资源，提升创作效率与内容质量。平台每日更新推荐优质内容，确保创作者始终获取最新、最实用的资源。",
  },
  {
    question: "如何快速找到我需要的成品资源？",
    answer: "您可以通过首页的搜索功能直接搜索关键词，也可以浏览分类导航进入对应品类页面。每个分类下都有详细的资源列表，支持按发布时间、热度等维度排序。我们还提供标签筛选功能，帮助您精准定位所需资源类型。",
  },
  {
    question: "平台上的资源是否免费使用？",
    answer: "平台提供了丰富的免费资源供创作者使用，包括基础教程、素材模板和灵感案例等。部分高级成品资源和专业工具可能需要付费获取，我们会在资源详情页明确标注。我们致力于为不同阶段的创作者提供适合的资源选择。",
  },
  {
    question: "如何成为蘑菇tv成品人的认证创作者？",
    answer: "您可以在平台上注册账号后，进入个人中心提交创作者认证申请。认证条件包括：在蘑菇tv平台拥有活跃账号、发布过原创内容、遵守社区规范等。通过认证后，您可以发布自己的成品资源、参与平台活动并获得更多曝光机会。",
  },
  {
    question: "平台上的教程内容适合新手吗？",
    answer: "非常适合！我们的创作教程按照难度分级，从零基础入门到高级技巧都有覆盖。「新手专区」提供了系统的入门指引和基础操作教程，帮助新创作者快速上手。同时每篇教程都配有详细的图文说明和视频演示，确保学习体验友好顺畅。",
  },
  {
    question: "遇到问题如何联系平台客服？",
    answer: "您可以通过以下方式联系我们：发送邮件至 contact@mogutv.com，或在工作日9:00-18:00拨打客服热线400-888-9999。也可以关注我们的官方微信公众号「mogutv_official」获取最新资讯和在线客服支持。我们承诺在工作时间内2小时内响应您的咨询。",
  },
];